import { createFunctionalBridgeComponent } from './functional-bridge.js';
function builder(ComponentType, metadata) {
    const name = ComponentType.name;
    return createFunctionalBridgeComponent(`${name}[FunctionalBridge]`, ComponentType, metadata);
}
export { builder, };
//# sourceMappingURL=builder.js.map